<template>
  <BsCallout
    :id="id"
    style="border-radius: 0"
    :variant="variant"
  >
    <div class="row" style="vertical-align: middle">
      <div class="col-md-7">
        <h4>{{ visitor.personal.fullname_first }} {{ visitor.personal.fullname_patronymic }} {{ visitor.personal.fullname_last }}</h4>
      </div>
      <div class="col-md-3">
        <slot name="headerExtraInfo"></slot>
      </div>
      <div class="col-md-2">
        <b-button
          @click="expanded = !expanded"
        >
          <i v-if="!expanded" class="glyphicon glyphicon-menu-down"></i>
          <i v-else class="glyphicon glyphicon-menu-up"></i>
        </b-button>
        <slot name="menu" />
      </div>
    </div>
    <div class="worker-list-item-expand" v-if="expanded">
      <div class="row">
        <CommonInfoPlace label="Дата рождения" :value="visitor.personal.birthday" />
        <CommonInfoPlace
          label="Место рождения"
          :breakpoints="{xs: 6, md: 6}"
          :value="visitor.personal.placebirth"
        />
        <div class="col-xs-3 col-md-3">
          <span class="name-label">Гражданство</span>
          <p>
            <img
              class="visitor.personal-flag"
              height="8" :src="getVesselFlagImage"
              alt="Country flag icon"
              v-if="getVesselFlagImage"
            />
            {{ nationality ? nationality.name : null }}
          </p>
        </div>
      </div>
      <div class="row">
        <CommonInfoPlace label="Вид документа" :value="identification ? identification.name : '-'" />
        <CommonInfoPlace label="Серия и номер">
          {{ visitor.personal.identification_number }}
        </CommonInfoPlace>
        <CommonInfoPlace label="Дата выдачи">
          {{ visitor.personal.identification_date_of }}
        </CommonInfoPlace>
        <CommonInfoPlace label="Дата окончания">
          {{ visitor.personal.identification_date_to ? visitor.personal.identification_date_to : '-' }}
        </CommonInfoPlace>
      </div>
      <div class="row">
        <CommonInfoPlace :breakpoints="{md: 9, xs: 9}" label="Кем выдан" :value="visitor.personal.identification_place" />
        <CommonInfoPlace label="Код подразделения" :value="visitor.personal.identification_code" />
      </div>
      <div class="row">
        <CommonInfoPlace :breakpoints="{md: 6, xs: 6}" label="Адрес" :value="visitor.personal.address" />
        <CommonInfoPlace label="Телефон" :value="visitor.personal.phone" />
        <CommonInfoPlace label="Должность" :value="visitor.personal.status" />
      </div>
      <div class="row">
        <CommonInfoPlace label="Наименование организации" :value="visitor.personal.organization_name ? visitor.personal.organization_name : '-'" />
        <CommonInfoPlace label="ИНН" :value="visitor.personal.organization_inn ? visitor.personal.organization_inn : '-'" />
      </div>
      <div class="row">
        <CommonInfoPlace label="Тип">
        </CommonInfoPlace>
        <CommonInfoPlace label="Марка / Модель" :value="visitor.auto !== undefined ? `${visitor.auto.mark} ${visitor.auto.model}` : '-'" />
        <CommonInfoPlace label="Цвет" :value="visitor.auto !== undefined ? `${visitor.auto.color}` : '-'" />
        <CommonInfoPlace label="Собственник" :value="visitor.auto !== undefined ? `${visitor.auto.owner}` : '-'" />
      </div>
    </div>
  </BsCallout>
</template>

<script>
/** TODO Реализовать ограничение на доспуп добавления сотрудника */

import BsCallout from '../BsCallout/BsCallout'
import CommonInfoPlace from '../application/review-form/visitors/DefaultCollumn'

export default {
  name: 'VisitorInfo',
  components: { BsCallout, CommonInfoPlace },
  props: {
    id: {
      type: String,
      default: 'VisitorInfo'
    },
    identification: {
      type: Object
    },
    nationality: {
      type: Object
    },
    variant: {
      type: String
    },
    visitor: {
      type: Object
    }
  },

  computed: {
    getVesselFlagImage () {
      if (!this.nationality || !this.nationality.iso2 || this.nationality.iso2 === 'YU') {
        return null
      }

      return `${process.env.BASE_URL}/img/icons/countries/${this.nationality.iso2}.svg`
    }
  },

  data () {
    return {
      expanded: false
    }
  }
}
</script>
